<div class="card-body">
  <div [hidden]="aba !== 5 || possuiCapitulos || possuiAnexo || visualizar">
    <div class="row">
      <div class="form-group col-md-6">
        <label for="modeloRelatorioId" class="mb-1">Modelo de Relatório</label>
        <div class="input-group input-group-sm" style="width: 100%;">
          <input type="text" id="modeloRelatorioId" class="form-control form-control-sm" readonly
            [ngModel]="model?.modeloRelatorio?.nome" [ngModelOptions]="{ standalone: true }" />
          <div class="input-group-append">
            <button [hidden]="visualizar" [disabled]="!model?.habilitarGerarRelatoria" type="button"
              class="btn btn-info mr-1" (click)="exibirModalModeloRelatorio()">
              <i class="fas fa-search"></i>
            </button>
          </div>
          <button [hidden]="visualizar" type="button" class="btn btn-success btn-sm" (click)="gerar()"
            [disabled]="!model?.habilitarGerarRelatoria && !model?.modeloRelatorio?.nome">
            Gerar
          </button>
        </div>
      </div>
    </div>
  </div>
  <div [hidden]="aba !== 5 || possuiCapitulos || possuiAnexo">
    <p>Ainda não existe um relatorio gerado</p>
  </div>

  <div [hidden]="aba !== 5 || !podeExibirUploadRelatoria">
    <div class="row">
      <div class="col-md-12 mb-3">
        <label class="mb-1">Upload da relatoria</label>
        <div class="mat-elevation-z4">
          <table mat-table [dataSource]="dataSourceAnexo" class="w-100">
            <tr mat-header-row *matHeaderRowDef="['arquivo', 'acoes']" class="bg-light"></tr>
            <ng-container matColumnDef="arquivo">
              <th mat-header-cell *matHeaderCellDef>Arquivo</th>
              <td mat-cell *matCellDef="let element">
                <a href="javascript:void(0)" class="link-download" (click)="download(element)">
                  {{ element?.nomeArquivo }}
                </a>
              </td>
            </ng-container>
            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef class="text-right">
                <span *ngIf="!visualizar && podeUploadRelatoria && !possuiAnexo">
                  <label for="anexoRelatoria" class="btn btn-success btn-xs">Adicionar</label>
                  <input type="file" id="anexoRelatoria" style="display:none" [accept]="acceptTypes"
                    (change)="anexarArquivo($event)">
                </span>
              </th>
              <td mat-cell *matCellDef="let element">
                <button type="button" class="btn btn-danger btn-xs btn-download-relatoria"
                  *ngIf="!visualizar && podeUploadRelatoria" (click)="excluirArquivoAnexo(element?.id)">
                  <i class="far fa-trash-alt"></i>
                </button>
                <button type="button" class="btn btn-info btn-xs" (click)="download(element)">
                  <i class="fas fa-download"></i>
                </button>
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: ['arquivo', 'acoes']"></tr>
          </table>
          <h5 [hidden]="possuiAnexo" class="table-no-data">Nenhum arquivo anexado</h5>
        </div>
      </div>
    </div>
  </div>

  <div [hidden]="aba !== 5 || !possuiCapitulos">
    <div class="row">
      <label class="mb-1">{{this.tituloModeloRelatorio}} - {{this.tituloDocumento }}</label>
    </div>
    <app-capitulo [impressao]="impressao" [relatoriaDados]="relatoriaDados" [somenteLeitura]="visualizar" [id]="id"
      [dadosObtidos]="dadosObtidos" [obterDados]="obterDados" [model]="model" [reprovado]="reprovado"
      [homologado]="homologado" [emAprovacao]="emAprovacao" [obterRelatorio]="obterRelatorio"
      [tipoTrabalhoRef]="tipoTrabalhoRef" [modelPagina]="modelPagina"></app-capitulo>
  </div>
</div>

<div class="card-footer">
  <button [hidden]="tipoTrabalho != 2" type="button" class="btn btn-default btn-sm mr-1" (click)="cancelar()">
    <i class="fas fa-times"></i> Fechar
  </button>
  <button [hidden]="visualizar || (tipoTrabalho != 2 &&  tipoTrabalho != 8)" type="button"
    class="btn btn-warning btn-sm mr-1" (click)="enviarAprovacao()" [disabled]="desabilitarBotaoEnviarAprovacao()">
    <i class="far fa-save"></i> Enviar para Aprovação
  </button>
</div>